import { NgModule } from '@angular/core';
import { PageMetadataModule } from '@app/router';
import { AlertMetaModule } from '@pages/alerts/alert-meta.module';
import { AnalyticsMetaModule } from '@pages/analytics/analytics-meta.module';
import { AssetMetaModule } from '@pages/assets/asset-meta.module';
import { AuditMetaModule } from '@pages/audit/audit-meta.module';
import { AuthMetaModule } from '@pages/auth/auth-meta.module';
import { CredentialStoresMetaModule } from '@pages/credential-stores/credential-stores-meta.module';
import { EnvironmentMetaModule } from '@pages/environments/environment-meta.module';
import { FoldersMetaModule } from '@pages/folders/folders-meta.module';
import { HostMetaModule } from '@pages/host/host-meta.module';
import { JobMetaModule } from '@pages/jobs/job-meta.module';
import { LicenseMetaModule } from '@pages/license/license-meta.module';
import { LogMetaModule } from '@pages/logs/log-meta.module';
import { MachineMetaModule } from '@pages/machines/machine-meta.module';
import { MLMetaModule } from '@pages/ml/ml-meta.module';
import { MonitoringMetaModule } from '@pages/monitoring/monitoring-meta.module';
import { NugetMetaModule } from '@pages/packages/nuget-meta.module';
import { ProcessMetaModule } from '@pages/process/process-meta.module';
import { ProfileMetaModule } from '@pages/profile/profile-meta.module';
import { QueueMetaModule } from '@pages/queues/queue-meta.module';
import { RobotMetaModule } from '@pages/robots/robot-meta.module';
import { RoleMetaModule } from '@pages/roles/role-meta.module';
import { SettingsMetaModule } from '@pages/settings/settings-meta.module';
import { SharedMetaModule } from '@pages/shared/shared-page-meta.module';
import { StatsMetaModule } from '@pages/stats/stats-meta.module';
import { TasksMetaModule } from '@pages/tasks/tasks-meta.module';
import { TransactionMetaModule } from '@pages/transactions/transaction-meta.module';
import { TriggersMetaModule } from '@pages/triggers/triggers-meta.module';
import { UserMetaModule } from '@pages/users/user-meta.module';
import { WebhookMetaModule } from '@pages/webhooks/webhook-meta.module';

@NgModule({
    imports: [
        AuthMetaModule.forRoot(),
        AlertMetaModule.forRoot(),
        AssetMetaModule.forRoot(),
        AuditMetaModule.forRoot(),
        CredentialStoresMetaModule.forRoot(),
        EnvironmentMetaModule.forRoot(),
        JobMetaModule.forRoot(),
        LicenseMetaModule.forRoot(),
        LogMetaModule.forRoot(),
        MachineMetaModule.forRoot(),
        MonitoringMetaModule.forRoot(),
        MLMetaModule.forRoot(),
        NugetMetaModule.forRoot(),
        ProcessMetaModule.forRoot(),
        ProfileMetaModule.forRoot(),
        HostMetaModule.forRoot(),
        QueueMetaModule.forRoot(),
        RobotMetaModule.forRoot(),
        RoleMetaModule.forRoot(),
        TriggersMetaModule.forRoot(),
        SettingsMetaModule.forRoot(),
        StatsMetaModule.forRoot(),
        TasksMetaModule.forRoot(),
        TransactionMetaModule.forRoot(),
        UserMetaModule.forRoot(),
        WebhookMetaModule.forRoot(),
        SharedMetaModule.forRoot(),
        FoldersMetaModule.forRoot(),
        PageMetadataModule.forRoot(),
        AnalyticsMetaModule.forRoot(),
    ],
})
export class UiPathMetaModule { }
